import { EmailIcon, PhoneIcon, SmsIcon } from '#/shared/ui/icons'

import { MASS_CHANNEL, MASS_STATUS } from '../model/types'
import type { MassChannel, MassStatus } from '../model/types'

type IconComponent = React.ComponentType<{ className?: string }>

export interface Tone {
  stroke: string
  icon: string
  dot: string
  /** Tinted disc behind the ring (live-telephony orange states only). */
  bg?: string
}

export const TONE = {
  idle: {
    stroke: 'stroke-warm-100',
    icon: 'text-gray-300',
    dot: 'bg-gray-300',
  },
  blue: {
    stroke: 'stroke-blue-500',
    icon: 'text-blue-500',
    dot: 'bg-blue-500',
  },
  green: {
    stroke: 'stroke-green-500',
    icon: 'text-green-500',
    dot: 'bg-green-500',
  },
  orange: {
    stroke: 'stroke-orange-550',
    icon: 'text-orange-550',
    dot: 'bg-green-750',
    bg: 'bg-orange-50',
  },
} as const satisfies Record<string, Tone>

export const CHANNEL_ICON: Record<MassChannel, IconComponent> = {
  [MASS_CHANNEL.sms]: SmsIcon,
  [MASS_CHANNEL.email]: EmailIcon,
  [MASS_CHANNEL.phone]: PhoneIcon,
}

const STATUS_TONE: Partial<Record<MassStatus, keyof typeof TONE>> = {
  [MASS_STATUS.dialing]: 'green',
  [MASS_STATUS.onCall]: 'orange',
}

export function resolveTone(status: MassStatus): Tone {
  if (status === MASS_STATUS.idle) return TONE.idle
  const key = STATUS_TONE[status] ?? 'blue'
  return TONE[key]
}

export function statusLabelKey(
  channel: MassChannel,
  status: MassStatus,
): string {
  if (status === MASS_STATUS.onCall) return 'massAction.status.onCall'
  if (status === MASS_STATUS.dialing) return 'massAction.status.dialing'
  return `massAction.status.sending.${channel}`
}
